import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from '@environment';

Sentry.init({
  dsn: 'https://4b7a6db461b1c80e0baad85046b3ad50@o4511632967401472.ingest.de.sentry.io/4511647950700624',
  environment: environment.name,
  integrations: [Sentry.replayIntegration()],
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
